import React from "react";
import PromocaoCampanhaService from "../../services/PromocaoCampanhaService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaPromocaoCampanha extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: PromocaoCampanhaService,
            labels: {
                title: 'Lista de Campanha(s)',
                btnNewRegister: 'Campanha',
            },
            keyItem: 'idPromocaoCampanha',
            urlForm: '/CadPromocaoCampanha',
            itensFilter: ["idPromocaoCampanha", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-5"> Nome </th>
                <th className="col-md-5"> Apresentação </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idPromocaoCampanha}</td>
                <td>{item.nome}</td>
                <td>
                    <span className="badge fs-7 w-100" style={{ backgroundColor: item.cdBgColor, color: item.cdTxColor }}>
                        {item.nome}
                    </span>
                </td>
            </>);
    }

    render() {
        return super.render();
    }
}